import * as React from 'react';
import { NextRouter, useRouter } from 'next/router';
import Head from 'next/head';
import getConfig from 'next/config';
import qs from 'qs';

export type Props = {
  title?: string;
  description?: string;
  thumbnail?: string;
  paginated?: {
    router: NextRouter;
    lastPage?: number;
  };
  canonical?: string;
  noindex?: boolean;
  hideTitlePrefix?: boolean;
};

function MetaTags(props: Props) {
  const { nextPage, prevPage } = getPaginationTags(props.paginated);
  const { publicRuntimeConfig } = getConfig();
  const titleSuffix = props.hideTitlePrefix
    ? ''
    : publicRuntimeConfig.seo?.titleSuffix;
  return (
    <Head>
      <title>
        {props.title}
        {titleSuffix}
      </title>
      <meta name="description" content={props.description} key="description" />
      <meta property="og:title" content={props.title} key="og:title" />
      <meta
        property="og:description"
        content={props.description}
        key="og:description"
      />
      <meta
        property="og:image"
        content={props.thumbnail || '/shared/metaDefault.png'}
        key="og:image"
      />
      <meta name="twitter:title" content={props.title} key="twitter:title" />
      <meta
        name="twitter:description"
        content={props.description}
        key="twitter:description"
      />
      <meta
        name="twitter:image"
        content={props.thumbnail || '/shared/metaDefault.png'}
        key="twitter:image"
      />
      {(props.noindex || publicRuntimeConfig.APP_ENV === 'staging') && (
        <meta name="robots" content="noindex" />
      )}
      <meta
        name="google-site-verification"
        content="t8_dg-N4OXVuHmGFB45ninmseZUrX3xD7r1ScBfzLgQ"
      />
      {props.canonical && <link rel="canonical" href={props.canonical} />}
      {nextPage && <link rel="next" href={nextPage} />}
      {prevPage && <link rel="prev" href={prevPage} />}
    </Head>
  );
}

const getPaginationTags = (paginated: any) => {
  let nextPage, prevPage;

  if (paginated) {
    const { lastPage, router } = paginated;
    const page = parseInt(router.query.page as string) || 1;
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const queryStrings = (page: number) =>
      qs.stringify(
        {
          page,
          term: router.query.term
        },
        {
          addQueryPrefix: true
        }
      );

    nextPage =
      +page < lastPage && `${origin}${router.route}${queryStrings(+page + 1)}`;
    prevPage =
      +page > 1 && `${origin}${router.route}${queryStrings(+page - 1)}`;
  }

  return {
    nextPage,
    prevPage
  };
};

MetaTags.defaultProps = {
  title: 'Morressier',
  description: 'Welcome to the largest platform for early-stage research'
};
export default MetaTags;
